import script from "./GaleriaLoop.vue?vue&type=script&setup=true&lang=js"
export * from "./GaleriaLoop.vue?vue&type=script&setup=true&lang=js"

import "./GaleriaLoop.vue?vue&type=style&index=0&id=6692e57c&lang=css"

const __exports__ = script;

export default __exports__